// extracted by mini-css-extract-plugin
export const callBlock = "callButtonStyle-module--call-block--1ak1n";